import { handleOpenWebsiteInWebview } from './utils';
// access to native Pollfish SDK interface
Pollfish.mobile.interface.sdk = (function sdk() {
  const ravenBreadcrumb = (category, data) => {
    Raven.captureBreadcrumb({
      message: 'interface.sdk',
      category,
      data,
    });

    // Piggyback on Raven calls to inform iOS that the functions were called.
    // NOTE: un-comment if you want logging on iOS
    // if (Pollfish.helper.isWKWebview()) {
    //   window.webkit.messageHandlers.pollfish.postMessage({
    //     command: 'functionCalled',
    //     name: category,
    //     params: data || 'no_params_given',
    //     type_of_param: typeof data,
    //   });
    // }
  };

  const webkitEvents = {};
  const awaitResponse = (event, successCallback) => {
    if (!webkitEvents[event]) {
      webkitEvents[event] = [];
    }
    webkitEvents[event].push(successCallback);
  };

  return {
    // mark a user as not eligible for the survey
    userNotEligible() {
      ravenBreadcrumb('userNotEligible');
      // legacy fallback
      if (Pollfish.helper.json.sdk_version > 5) {
        try {
          if (Pollfish.helper.isWKWebview()) {
            window.webkit.messageHandlers.pollfish.postMessage({
              command: 'userNotEligible',
            });
          } else {
            Native.userNotEligible();
          }
        } catch (err) {
          window.onerror(err, 'not available', 'not available');
        }
      }
    },

    // send the device data after user consent
    sentDataOfUserConsentToServer(url, shouldSendInstalledApps) {
      ravenBreadcrumb('sentDataOfUserConsentToServer', {
        url,
        shouldSendInstalledApps,
      });
      // legacy fallback
      if (Pollfish.helper.json.sdk_version > 5) {
        if (Pollfish.helper.isAndroid()) {
          try {
            if (Pollfish.helper.json.sdk_version > 11) {
              ravenBreadcrumb('Native.sentDataOfUserConsentToServerNew');

              if (
                Native &&
                typeof Native.sentDataOfUserConsentToServerNew === 'function'
              ) {
                let bits = '100001110';
                if (shouldSendInstalledApps) {
                  bits = '100001111';
                }

                bits = '000000000'; // TODO: removed hastyly when a publisher was banned. Need to check again
                // Native.sentDataOfUserConsentToServerNew(url, '0111', bits);
                Native.sentDataOfUserConsentToServerNew(url, '0000', bits);
              }
            } else {
              ravenBreadcrumb('Native.sentDataOfUserConsentToServer');
              if (
                Native &&
                typeof Native.sentDataOfUserConsentToServer === 'function'
              ) {
                // Native.sentDataOfUserConsentToServer(url, '0111');
                Native.sentDataOfUserConsentToServer(url, '0000');
              }
            }
          } catch (err) {
            window.onerror(err, 'not available', 'not available');
          }
        }
      }
    },

    // close panel and show indicator
    close() {
      ravenBreadcrumb('close');
      $('html').click();
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'close',
        });
      } else if (Native && typeof Native.close === 'function') {
        Native.close();
      }
    },

    // close panel and don't show indicator
    closeAndNoShow() {
      ravenBreadcrumb('closeAndNoShow');

      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'closeAndNoShow',
        });
      } else if (Native && typeof Native.closeAndNoShow === 'function') {
        Native.closeAndNoShow();
      }
    },

    // inform SDK that the survey is finished
    setSurveyCompleted(payload) {
      ravenBreadcrumb('setSurveyCompleted');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'setSurveyCompleted',
          ...payload,
        });
      } else if (Native && typeof Native.setSurveyCompleted === 'function') {
        if (Pollfish.helper.androidSupportsJSONParams()) {
          Native.setSurveyCompleted(JSON.stringify({ ...payload }));
        } else {
          Native.setSurveyCompleted();
        }
      }
    },

    // present simple pop-up native message
    showToastMsg(msg) {
      ravenBreadcrumb('showToastMsg', { msg });
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'showToastMsg',
          msg,
        });
      } else if (Native && typeof Native.showToastMsg === 'function') {
        Native.showToastMsg(msg);
      }
    },

    // open website in native browser out of app
    openWebsite(url) {
      ravenBreadcrumb('openWebsite', { url });
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'openWebsite',
          url,
        });
      } else if (Native && typeof Native.openWebsite === 'function') {
        Native.openWebsite(url);
      }
    },

    // open website within the existing webview for 3rd party rendering.
    // Compatibility notice: Older SDK versions do not have the openWebsiteInWebview
    //                       available, therefore we fallback to openWebsite
    openWebsiteInWebview(url, surveyByTxt, providerName, action) {
      const providerImgPath = `./img/${providerName}.png`;
      const payload = {
        url,
        surveyByTxt,
        providerImgPath,
        action,
      };
      ravenBreadcrumb('openWebsiteInWebview', payload);
      if (Pollfish.helper.isWKWebview()) {
        Pollfish.ui.thirdPartyLoader();
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'openWebsiteInWebview',
          ...payload,
        });
      } else if (Native && typeof Native.openWebsiteInWebview === 'function') {
        handleOpenWebsiteInWebview(url, surveyByTxt, providerName, payload);
      } else if (Native && typeof Native.openWebsite === 'function') {
        Native.openWebsite(url);
        Pollfish.mobile.interface.closeAndNoShow();
      }
    },

    hideMediationViews() {
      ravenBreadcrumb('hideMediationViews');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'hideMediationViews',
        });
      } else if (Native && typeof Native.hideMediationViews === 'function') {
        Native.hideMediationViews();
      }
    },

    userRejectedSurvey() {
      ravenBreadcrumb('userRejectedSurvey');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'userRejectedSurvey',
        });
      } else if (Native && typeof Native.userRejectedSurvey === 'function') {
        Native.userRejectedSurvey();
      }
    },

    noSurveyFound() {
      ravenBreadcrumb('noSurveyFound');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'noSurveyFound',
        });
      } else if (Native && typeof Native.noSurveyFound === 'function') {
        Native.noSurveyFound();
      }
    },

    // notify SDK when everything is loaded
    webViewLoaded() {
      ravenBreadcrumb('webViewLoaded');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'webViewLoaded',
        });
      } else if (Native && typeof Native.webViewLoaded === 'function') {
        Native.webViewLoaded();
      }
    },

    // get data from server in json format
    getFromServer(responseCallback) {
      ravenBreadcrumb('getFromServer');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'getFromServer',
        });
        awaitResponse('getFromServer', responseCallback);
        return;
      }
      if (window.Native && typeof Native.getFromServer === 'function') {
        const data = Native.getFromServer();
        responseCallback(data);
        return;
      }

      setTimeout(() => {
        if (
          (window.Native && window.Native.getFromServer) ||
          Pollfish.helper.isWKWebview()
        ) {
          Pollfish.analytics.sendEvent(
            'investigation',
            'asyncNativeEnvironment',
            'Found Native/WKWebview Environment after 5s delay',
          );
        }
      }, 5000);
      Raven.captureException('device has no Native or WKWebview', {
        extra: {
          hasWebview: Pollfish.helper.isWKWebview(),
          hasResponseCallback: typeof responseCallback,
          hostName: Pollfish.helper.getBaseRequestURL(),
          locationProtocol: window.location.protocol,
          locationHost: window.location.host,
          messageHandlers: window.webkit && window.webkit.messageHandlers,
          isAPI: Pollfish.helper.isAPI(),
          currentKnownData: Pollfish.helper.json,
          deviceType: Pollfish.helper.getDeviceType(),
          htmlJSON: Pollfish.helper.html.json,
        },
      });
      responseCallback(false);
    },

    didGetFromServer(responseData) {
      ravenBreadcrumb('getFromServer');
      if (
        !webkitEvents.getFromServer ||
        !(webkitEvents.getFromServer instanceof Array) ||
        webkitEvents.getFromServer.length < 1
      ) {
        throw new Error(
          'didGetFromServer was called while the webkitEvents.getFromServer was empty',
        );
      }
      // getFromServer expects JSON string. iOS will send over JSON so we are doing some naive
      // calculations here. We should probably revisit this and make this better
      let storedCallback = webkitEvents.getFromServer.pop();
      let data = responseData;
      if (typeof responseData === 'object') {
        data = JSON.stringify(responseData);
      }
      while (storedCallback) {
        storedCallback(data);
        storedCallback = webkitEvents.getFromServer.pop();
      }
    },

    // clear the queue cache
    clearCacheQueue() {
      ravenBreadcrumb('clearCacheQueue');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'clearCacheQueue',
        });
      } else if (Native && typeof Native.clearCacheQueue === 'function') {
        Native.clearCacheQueue();
      }
    },

    // send information to server
    sendToServer(url, data, saveAtQueue) {
      ravenBreadcrumb('sendToServer', { url, data, saveAtQueue });
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'sendToServer',
          url,
          params: data,
          saveAtQueue,
        });
      } else if (Native && typeof Native.sendToServer === 'function') {
        Native.sendToServer(url, data, saveAtQueue);
      }
    },

    // get device information to handle js and css compatibility
    getDeviceInfo(responseCallback) {
      ravenBreadcrumb('getDeviceInfo');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'getDeviceInfo',
        });
        awaitResponse('getDeviceInfo', responseCallback);
        return;
      }
      if (Native && typeof Native.getDeviceInfo === 'function') {
        Native.getDeviceInfo();
      }
      responseCallback({});
    },

    didGetDeviceInfo(responseData) {
      ravenBreadcrumb('didGetDeviceInfo');
      if (
        !webkitEvents.getDeviceInfo ||
        !(webkitEvents.getDeviceInfo instanceof Array) ||
        webkitEvents.getDeviceInfo.length < 1
      ) {
        // TODO: Check what happens here
        throw new Error(
          'didGetDeviceInfo was called while the webkitEvents.queue was empty',
        );
      }
      let storedCallback = webkitEvents.getDeviceInfo.pop();
      let data = responseData;
      // getDeviceInfo expects JSON string. iOS will send over JSON so we are doing some naive
      // calculations here. We should probably revisit this and make this better
      if (typeof responseData === 'object') {
        data = JSON.stringify(responseData);
      }
      while (storedCallback) {
        storedCallback(data);
        storedCallback = webkitEvents.getDeviceInfo.pop();
      }
    },

    // notify SDK that the focus is no the input
    textFieldFocus() {
      ravenBreadcrumb('textFieldFocus');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'textFieldFocus',
        });
      } else if (Native && typeof Native.textFieldFocus === 'function') {
        Native.textFieldFocus();
      }
    },

    // notify SDK that the focus is lost from input
    textFieldUnFocus() {
      ravenBreadcrumb('textFieldUnFocus');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'textFieldUnFocus',
        });
      } else if (Native && typeof Native.textFieldUnFocus === 'function') {
        Native.textFieldUnFocus();
      }
    },

    // notify SDK that the video has ended
    notifyVideoEnd() {
      ravenBreadcrumb('notifyVideoEnd');
      if (Pollfish.helper.isWKWebview()) {
        window.webkit.messageHandlers.pollfish.postMessage({
          command: 'notifyVideoEnd',
        });
      } else if (Native && typeof Native.notifyVideoEnd === 'function') {
        Native.notifyVideoEnd();
      }

      if (Pollfish.ui.video) {
        // ios only
        Pollfish.helper.exitFullScreenVideo();
      }
    },

    // interface for calls from SDK start

    // ios only focus on input of email for winner
    focusExplicitly(browserHeight) {
      ravenBreadcrumb('focusExplicitly', browserHeight);
      $('body').height(browserHeight);

      $('#congratsForWin').hide();

      Pollfish.ui.emailInputFocus = true;

      $('#emailInput input').focus();
    },

    // remove focus from input of email for winner
    loseFocus(emailInputFocus) {
      ravenBreadcrumb('loseFocus', emailInputFocus);
      Pollfish.ui.emailInputFocus = emailInputFocus;

      $('#congratsForWin').show();
      $('#freeTextNumerical').blur();
    },

    panelClosed() {
      ravenBreadcrumb('panelClosed');
      if (Pollfish.ui.video) {
        Pollfish.ui.video.pause();
      }
    },

    panelOpened() {
      ravenBreadcrumb('panelOpened');
      // do nothing
    },

    playVideo() {
      ravenBreadcrumb('playVideo');
      if (Pollfish.ui.video) {
        Pollfish.ui.video.play();
      }
    },

    pauseVideo() {
      ravenBreadcrumb('pauseVideo');
      if (Pollfish.ui.video) {
        Pollfish.ui.video.pause();
      }
    },

    webViewFocus(isFocused) {
      ravenBreadcrumb('webViewFocus', isFocused);
      if (!isFocused) {
        Pollfish.ui.showOverlaySpinner();
        if (Pollfish.ui.video) {
          Pollfish.ui.video.pause();
        }
      } else {
        setTimeout(Pollfish.ui.hideOverlaySpinner, 0);
      }
    },

    // ios only function to exit full screen
    exitFullScreen(mode) {
      ravenBreadcrumb('exitFullScreen', mode);
      if (Pollfish.ui.video) {
        Pollfish.helper.exitFullScreenVideo();

        if (mode) {
          Pollfish.ui.video.pause();
        }
      }
    },

    // interface for calls from SDK end
  };
})();

export default Pollfish.mobile.interface.sdk;
